import { combineReducers } from 'redux';
import session from './session';
import snackbar from './snackbar';

export default combineReducers({
	session,
	snackbar,
});
